<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div>
  <div class="title border-bottom-1 mb-2 mt-5 titleblue orderdetails-title">
    <h4 class="m-0 text-black fw-bold">
      Expense Details
    </h4>
  </div>

  <p-table class="orderdetails" #pt [value]="expenseDetails" [lazy]="true" (onLazyLoad)="loadLazy($event)"
    dataKey="expenseDetailId" editMode="cell" (onEditComplete)="onCellEditComplete($event)"
    [paginator]="showPagination" [loading]="formLoading" [rows]="100" [rowsPerPageOptions]="[100,150,200]" showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
    sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
    [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
    <ng-template pTemplate="caption">
      <div class="d-block text-end orderdetails-btn">
        <span>
          @if (!outlineNewButton) {
            <button pButton pRipple class="p-button-outlined"
            style="padding: 0.643rem 0.75rem !important;" (click)="onOpenFormAdd()">New ExpenseDetail +</button>
          }
          @if (outlineNewButton) {
            <button pButton pRipple class="p-button"
            style="padding: 0.643rem 0.75rem !important;" (click)="onOpenFormAdd()">New ExpenseDetail +</button>
          }
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'description'" [ngStyle]="{'width': 'auto'}">Description</th>
        <th [pSortableColumn]="'quantity'" [ngStyle]="{'width': '60px'}">&#35;</th>
        <th [ngStyle]="{'width': '110px'}">Paid By</th>
        <th [pSortableColumn]="'amount'" [ngStyle]="{'width': '110px'}">Price</th>
        <th [ngStyle]="{'width': '110px'}">Sub Total</th>
        <th [ngStyle]="{'width': '90px'}">Tax</th>
        <th [ngStyle]="{'width': '110px'}">Total</th>
        <th [ngStyle]="{'width': '60px'}"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-expenseDetail let-index="rowIndex">
      <tr>
        <!-- Description — inline editable -->
        <td pEditableColumn style="white-space: break-spaces; width:100px">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="expenseDetail.description"
                style="width:100%; min-width:120px;" />
            </ng-template>
            <ng-template pTemplate="output">
              {{expenseDetail.description}}
            </ng-template>
          </p-cellEditor>
        </td>

        <!-- Quantity — inline editable -->
        <td pEditableColumn style="width:60px; text-align:right;">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="expenseDetail.quantity"
                style="width:60px; text-align:right;" />
            </ng-template>
            <ng-template pTemplate="output">
              {{expenseDetail.quantity}}
            </ng-template>
          </p-cellEditor>
        </td>

        <!-- Paid By — inline editable dropdown -->
        <td pEditableColumn class="text-end" style="width:110px;">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="paidByOptions" [(ngModel)]="expenseDetail.paidBy"
                optionLabel="label" optionValue="value"
                [style]="{'width':'100%'}"
                (onChange)="onCellEditComplete({data: expenseDetail})">
              </p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              {{expenseDetail?.paidBy ? paidByList[expenseDetail?.paidBy] : ''}}
            </ng-template>
          </p-cellEditor>
        </td>

        <!-- Price (amount) — inline editable number -->
        <td pEditableColumn style="text-align:right; width:110px;">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" step="0.01" [(ngModel)]="expenseDetail.amount"
                style="width:90px; text-align:right;" />
            </ng-template>
            <ng-template pTemplate="output">
              {{expenseDetail.amount | currency : 'USD'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <!-- Sub Total — read only -->
        <td style="text-align: right; width:110px;">{{expenseDetail?.subTotal | currency : 'USD'}}</td>
        <!-- Tax — read only -->
        <td style="text-align: right; width:90px;">{{expenseDetail.tax | currency : 'USD'}}</td>
        <!-- Total — read only -->
        <td style="text-align: right; width:110px;">{{expenseDetail.total | currency : 'USD'}}</td>
        <!-- Action column — pencil icon opens full edit dialog for this detail row -->
        <td style="text-align:center; width:60px;">
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
            (click)="onOpenFormEdit(expenseDetail)"></button>
        </td>
      </tr>

      @if ((expenseDetails.length - 1) == index) {
        <tr>
          <td></td>
          <td></td>
          <td class="text-end"><b>Total</b></td>
          <td class="text-end"><b>{{totalAmount() | currency : 'USD'}}</b></td>
          <td class="text-end"><b>{{totalTax() | currency : 'USD'}}</b></td>
          <td class="text-end"><b>{{grandTotal() | currency : 'USD'}}</b></td>
          <td></td>
          <td></td>
        </tr>
      }
      @if ((expenseDetails.length - 1) == index) {
        <tr>
          <td colspan="5" class="text-end"><b>Total Amount</b></td>
          <td class="text-end"><b>{{totalAmount() | currency : 'USD'}}</b></td>
          <td></td>
          <td></td>
        </tr>
      }
      @if ((expenseDetails.length - 1) == index) {
        <tr>
          <td colspan="5" class="text-end"><b>Total Taxes</b></td>
          <td style="text-align: right;"><b>{{totalTax() | currency : 'USD'}}</b></td>
          <td></td>
          <td></td>
        </tr>
      }
      @if ((expenseDetails.length - 1) == index) {
        <tr>
          <td colspan="5" style="font-weight: bold;">Grand Total</td>
          <td class="text-end"><b>{{grandTotal() | currency : 'USD'}}</b></td>
          <td></td>
          <td></td>
        </tr>
      }
    </ng-template>
  </p-table>

</div>
